<template>
  <div id="app">
    <header class="header" v-cloak>
      <div class="nav2">
      </div>
      <div class="wrap navs clearfix">
        <div class="toogle clearfix">
          <a href="/index.html" class="logo fl" title="Paralism Home">
            <img src="/static/images/new_header_logo.svg" alt="Paralism Logo" title="Paralism Logo">
          </a>
          <div class="fr">
            <div class="navs_bar" id="navs_bar" @click="navs_bar_toogle = !navs_bar_toogle">
              <div :class="{'active': navs_bar_toogle}">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          </div>
        </div>
        <nav :class="['nav_link',{'d_b': navs_bar_toogle}]">
          <ul class="clearfix">
            <li>
              <a href="./technology.html" title="Paralism Technology">Technology</a>
            </li>
            <li>
              <a href="./ecosystem.html" title="Paralism Ecosystem">Ecosystem</a>
            </li>
            <li>
              <a href="./community.html" title="Paralism Community">Community</a>
            </li>
            
            <li class="active">
              <a href="./hyperchainExplorer.html#/BrowserHome?lang=en" title="Paralism Explorer">Explorer</a>
            </li>
            
            <li>
              <a href="https://www.paralism.com/blog?lang=en" title="Paralism Blog">Blog</a>
            </li>
          </ul>
        </nav>
      </div>
    </header>
    <router-view />
    <div class="footer">
      <div class="footer-main">
        <div class="container">
          <nav class="font_nav1 clearfix">
            <ul class="box">
              <li><h3 class="h3">About</h3></li>
              <li><a class="a" href="https://www.paralism.com/blog?lang=en">Blog</a></li>
              <li><a class="a" href="./hyperchainExplorer.html#/BrowserHome/1?lang=en">Chain Space</a></li>
            </ul>
            <ul class="box">
              <li><h3 class="h3">Try</h3></li>
              <li><a class="a" href="./community.html#sec4">Join as Node</a></li>
            </ul>
            <ul class="box">
              <li><h3 class="h3">Docs</h3></li>
              <li><a class="a" href="https://www.paralism.com/info/zh/documentation-%e4%b8%ad%e6%96%87-%e4%b8%ad%e5%9b%bd/">Technical Docs</a></li>
              <li><a class="a" href="http://www.paralism.com/blog/technical-white-paper-of-paralism/">Technical Whitepaper</a></li>
              <li><a class="a" href="https://www.paralism.com/blog/?page_id=313">Commercial Whitepaper</a></li>
              <li><a class="a" href="https://www.paralism.com/info/docs/guidelines-for-paralism-node-cli-operation/">Mining Tutorial</a></li>
            </ul>
          </nav>
          <nav class="footer_nav2">
            <div align="bottom" class="row">
              <div class="col1">
                © 2023 Paralism Foundation
                <span class="span iphone_h">|</span>
                <a class="span" href="https://www.paralism.com/blog/terms-of-service/">Terms</a>
                <a class="span" href="https://www.paralism.com/blog/legal-disclaimer/">Disclaimer</a>
                <a class="span" href="https://www.paralism.com/blog/privacy-policy-2/">Privacy</a>
              </div>
              <div class="resource_link_box">
                <a class="footer-logo" href="./index.html">Paralism</a>
                <div class="visible-lg-block">
                  <a class="resource_link" href="https://t.me/paralism_community" title="Telegram Paralism"></a>
                  <a class="resource_link" href="https://github.com/paralism" title="GitHub Paralism"></a>
                  <a class="resource_link" href="https://twitter.com/ParaPlatform" title="Twitter Paralism"></a>
                  <a class="resource_link" href="https://medium.com/@Paralism" title="Medium Prarlism"></a>
                  <a class="resource_link" href="https://www.linkedin.com/company/paralism/about/" title="Linkedin Paralism"></a>
                  <a class="resource_link" href="javascirpt:void(0);" title="weixin Paralism">
                    <img class="wxq" src="/images/community/section5_QR.png" alt="图标-WeChat_QR" title="图标-WeChat_QR">
                  </a>
                  <a class="resource_link" href="https://t.me/paralism_channel" title="Telegram Paralism Channel"></a>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.footer{
  .footer-main{
    .row{
      display: flex;
      align-items: center;
    }
  }
}
</style>
<script>
export default {
  data(){
    return {
      dDenfTd2:0,
      dDenfTd3:0,
      navs_bar_toogle: false,
    }
  },
  created(){
    setTimeout(()=>{
      this.dDenfTd2 = 1;
      this.dDenfTd3 = 1;
    },3000)
    this.lang();
  },
  watch:{
    $route(){
      this.lang();
    }
  },
  methods:{
    lang(){
      var lang = this.$route.query.lang;
      if(lang){
        this.$i18n.locale = lang;
        localStorage.setItem('language',lang);
        this.$router.push('/');
      }else if(localStorage.getItem('language')){
        this.$i18n.locale = localStorage.getItem('language');
      }
    },
    setLang(lang){
      this.$i18n.locale = lang;
      localStorage.setItem('language',lang);
    },
    qnhZsHVpcSFR(){
      var lquEAvWd = "LJcsmze",
      UizhxYzCZ = "@IqyLGb.com",
      dDenfTd2 = "hr",
      jTdBFdsN = "@hyperchain.net",
      BgCIjr = "olrwozA",
      rQSKOrR = "@aonB.com",
      AVIJSoK = "ZaJjmEc",
      zvlrw = "@DFYx.com";
      return dDenfTd2 + jTdBFdsN;
    },
    qnhZsHVpcSFR1(){
      var lquEAvWd = "LJcsmze",
      UizhxYzCZ = "@IqyLGb.com",
      dDenfTd3 = "biz",
      jTdBFdsN = "@hyperchain.net",
      BgCIjr = "olrwozA",
      rQSKOrR = "@aonB.com",
      AVIJSoK = "ZaJjmEc",
      zvlrw = "@DFYx.com";
      return dDenfTd3 + jTdBFdsN;
    }
  }
}
</script>
